var componentRelated = {
    init: function () {
        if (!document.querySelector('.component-related-swiper')) {
            return;
        }
        var componentRelated = new Swiper('.component-related-swiper', {
            slidesPerView: 'auto',
            // slidesPerGroup: 1,
            // spaceBetween: 0,
            pagination: {
                el: '.component-related-pagination',
                type: 'progressbar',
            },
        })
    }
}
setTimeout(function () {
    componentRelated.init();
}, 500)
